/* eslint-disable @typescript-eslint/no-empty-function */
import { useNavigate } from 'react-router-dom'
import { CloseIcon } from 'assets/icons/CloseIcon'
import { DashboardCard, P } from 'styling/GlobalStyles'
import { IWidget } from 'types/dashboard.interface'
import { WidgetEditOverlay } from 'pages/Dashboard/Dashboard.styled'
import { WidgetHeader, WidgetTitle, WidgetDetailsLink } from './widgetParts.styled'
import { WidgetBody } from '../hrLayout.styled'
import { ShiftCoverageWidget } from './ShiftCoverageWidget'

export const HrShiftsWidget = ({ modalOpen, removeWidget, onDragOver, onDragStart, onDragDrop }: IWidget) => {
  const navigate = useNavigate()
  return (
    <DashboardCard
      draggable={modalOpen}
      onDragStartCapture={() => onDragStart('shifts', 1)}
      onDrop={onDragDrop}
      onDragEnd={(e) => e.preventDefault()}
      onDragOver={(e) => {
        e.preventDefault()
        onDragOver('shifts')
      }}
      width='1fr'
      style={{ gridArea: 'shifts', cursor: modalOpen ? 'grab' : 'normal' }}
    >
      {modalOpen && (
        <WidgetEditOverlay
          onClick={(e) => {
            removeWidget('shifts')
            e.stopPropagation()
          }}
        >
          <P>Remove Widget</P>
          <CloseIcon />
        </WidgetEditOverlay>
      )}
      <WidgetHeader>
        <WidgetTitle>Shift coverage</WidgetTitle>
        <WidgetDetailsLink onClick={() => navigate('/hr/schedule/coverage')}>Open matrix ›</WidgetDetailsLink>
      </WidgetHeader>
      <WidgetBody>
        <ShiftCoverageWidget />
      </WidgetBody>
    </DashboardCard>
  )
}
